import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lib-zc-sample-menu',
  template: `
    <p>
      zc-sample-menu works!
    </p>
  `,
  styles: []
})
export class ZcSampleMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
